import R from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';

export default class OrderedSelect extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {};
  }
  render() {
    const getClasses = (index) => ['btn', 'btn-default', ...(R.contains(index + 1, this.props.selections) ? ['active'] : []), ...(this.props.editable ? [] : ['disabled'])].join(' ');
    const getBgColor = (index) => ['#FFFFFF', '#5BC0DE', '#FF0000'][this.props.selections.indexOf(index + 1) + 1];
    return (
      <div style={{ margin: '30px 20px', backgroundColor: '#EEEEEE', padding: '20px 30px', borderRadius: '10px' }}>
        <b style={{ margin: '5px' }}>{this.props.text}</b>
        <center>
          <For each='option' of={this.props.options} index='index'>
            <span key={index} className={getClasses(index)} onKeyPress={this.handleKeyPress(index)} style={{ cursor: this.props.editable ? 'pointer' : '', backgroundColor: getBgColor(index), margin: '5px 0px', width: '100%' }} onClick={this.props.editable && this.handleClick(index)} tabIndex='0'>
              {option}
            </span>
          </For>
        </center>
      </div>
    );
  }
  handleKeyPress(index) {
    return (event) => {
        if (event.keyCode === 0 || event.keyCode === 32) {
        event.preventDefault();
        this.handleClick(index)();
      }  
    }
  }
  handleClick(index) {
    return () => {
      let newSelections;
      if (index + 1 === this.props.selections[0]) {
        newSelections = [0, 0];
      } else if (index + 1 === this.props.selections[1]) {
        newSelections = [this.props.selections[0], 0];
      } else if (this.props.selections.filter(R.identity).length === 2) {
        newSelections = [this.props.selections[0], index + 1];
      } else {
        newSelections = [...(this.props.selections.filter(R.identity)), index + 1];
        if (newSelections.length === 1) {
          newSelections.push(0);
        }
      }

      this.props.onChange(newSelections);
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/questionnaires/OrderedSelect.jsx